import { Component, EventEmitter, Input, Output } from '@angular/core';
import { QRInputAutocomplete } from 'src/app/models/qr-input-autocomplete.model';

type InputTypes = string | number | undefined;

@Component({
  selector: 'qr-input-autocomplete-with-service',
  templateUrl: './input-autocomplete-with-service.component.html',
  styleUrls: ['./input-autocomplete-with-service.component.scss'],
})
export class InputAutocompleteWithServiceComponent {
  // INPUTS
  @Input() config!: QRInputAutocomplete;
  @Input() isDisabled?: boolean = false;
  @Input() hasError?: boolean = false;
  @Input() value: InputTypes;
  @Input() isLoading?: boolean = false;
  @Input() noResults?: boolean = undefined;
  @Input() multilineAddressOptions = false;

  //OUTPUTS
  @Output() blurChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  //Opcion elegida
  @Output() selectedChange: EventEmitter<string> = new EventEmitter<string>();
  //Texto escrito
  @Output() writtenText: EventEmitter<string> = new EventEmitter<string>();

  filteredOptions: string[] = [];
  isOptionsVisible: boolean = false;
  selectedOption: InputTypes = undefined;

  listResponse: string[] = [];

  inputValue: InputTypes = '';

  // QUE LA LISTA SE OCULTE CUANDO HACES CLICK EN OTRO LADO
  // CONSTRUCTOT → private _eref: ElementRef
  // @HostListener('document:click', ['$event', '$event.target'])
  // onDocumentClicked(event: MouseEvent, targetElement: HTMLElement) {
  //   if (
  //     targetElement &&
  //     document.body.contains(targetElement) &&
  //     !this._eref.nativeElement.contains(targetElement)
  //   ) {
  //     this.isOptionsVisible = false;
  //   }
  // }

  // ngOnInit(): void {  }

  ngOnChanges() {
    this.listResponse = this.config?.options;

    if (this.noResults) {
      setTimeout(() => {
        this.noResults = false;
      }, 1500);
    }
  }

  clearInput() {
    this.selectedOption = undefined;
    this.listResponse = [];
    this.isOptionsVisible = false;
  }

  inputChange(value: InputTypes): void {
    if (value != this.inputValue && value != this.selectedOption) {
      this.inputValue = value;
      let text = value != undefined ? value.toString() : '';
      this.writtenText.emit(text);
    }
    this.isOptionsVisible = value != '' && value != undefined;
  }

  select(option: string): void {
    this.isOptionsVisible = false;
    this.selectedOption = option;
    this.selectedChange.emit(this.selectedOption);
  }
}
